import { render, staticRenderFns } from "./SuperviseList.vue?vue&type=template&id=13d624c2&scoped=true"
import script from "./SuperviseList.vue?vue&type=script&lang=ts"
export * from "./SuperviseList.vue?vue&type=script&lang=ts"
import style0 from "./SuperviseList.vue?vue&type=style&index=0&id=13d624c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d624c2",
  null
  
)

export default component.exports